import React, {useState} from 'react';
import {authAPI} from "../../../api/auth";
import {useAppSelector} from "../../../store/hooks";
import {inputClassName, labelClassName} from "../../common/forms/OptionsForm";
import Button from "../../common/elements/Button";

interface ILoginRequest {
    username: string
    password: string
}

const LoginForm = () => {
    const [loginData, setLoginData] = useState<ILoginRequest>({
        username: '',
        password: ''
    })

    const [login, {data, isLoading: isLoginLoading}] = authAPI.useLoginMutation()
    const [validate, {isLoading: isValidateLoading}] = authAPI.useValidateMutation()

    const clickHandler = async () => {
        const response = await login(loginData)
        if (response.data?.access_token) {
            validate()
        }
    }

    const changeForm = (e: React.ChangeEvent<HTMLInputElement>) => {
        const fieldName = e.target?.name
        const fieldValue = e.target?.value
        if (!fieldName || fieldValue === undefined) return;

        setLoginData({
            ...loginData,
            [fieldName]: fieldValue
        })
    }

    return (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center">
            <div className="w-[400px] border-[1px] shadow-[0_4px_9px_-4px_#332d2d] p-3 rounded-lg">
                <h3 className="text-xl font-bold text-center mb-4">Login</h3>
                <div className="row g-3">
                    <div className="col-12">
                        <div className="flex rounded-md shadow-sm w-full">
                            <label className={labelClassName} htmlFor="username">Username</label>
                            <input
                                onChange={changeForm}
                                value={loginData.username}
                                name="username"
                                type="text"
                                className="py-2 px-4 border-[2px] outline-none w-[50%]"
                            />
                        </div>

                    </div>
                    <div className="col-12 mb-3">
                        <div className="flex rounded-md shadow-sm w-full">
                            <label className={labelClassName} htmlFor="password">Password</label>
                            <input
                                onChange={changeForm}
                                value={loginData.password}
                                name="password"
                                type="password"
                                className="py-2 px-4 border-[2px] outline-none w-[50%]"
                            />
                        </div>
                    </div>
                    <div className="col-12 text-center">
                        <Button
                            type="button"
                            label="Enter"
                            onClick={clickHandler}
                            disabled={isLoginLoading || isValidateLoading || !loginData.password || !loginData.username}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;